import { CityAutocomplete } from '../autocomplete/city'
import { DataSender } from '../loaders'

/**
* FeaturedWidget
*/

class FeaturedWidget {
    constructor(target) {
        if(!target || !target.length) return;

        // properties
        this.target = target;
        this.widgetCampaignId = this.target.data('campaign-id');
        this.widgetId = this.target.data('id');
        this.widgetPosition = null;
        this.widgetType = this.target.data('type');
        this.widgetUrl = this.target.data('url');

        // layout
        this.overlay = this.target.find('.overlay');

        // init
        this.initWidget();
    }

    initWidget() {
        var that = this;
        var pathname = window.location.pathname.substr(1);
        pathname = pathname.substr(0, pathname.indexOf('/'));

        if(pathname == 'calendar') {
            this.widgetPosition = 'calendar_sidebar';
        }
        else if(pathname == 'event' || pathname == 'events') {
            this.widgetPosition = 'event_sidebar';
        }
        else if(pathname == 'host' || pathname == 'promoter') {
            this.widgetPosition = 'promoter_sidebar';
        }
        else {
            this.widgetPosition = 'yard_sidebar';
        }

        tracking.featuredCampaignDisplay(this.widgetCampaignId, this.widgetPosition);
        this.overlay.bind('mousedown', { reference: this }, this.overlayMousedownHandler);
    }

    overlayMousedownHandler(e) {
        var that = e.data.reference;

        if(e.which <= 2) {
            var clickTarget = $(e.target);

            if(clickTarget.hasClass('action') || clickTarget.parents('a.action').length) {
                clickTarget = that.target.find('a.action');

                if(clickTarget.hasClass('active')) {
                    that.open();
                }
                else if(clickTarget.hasClass('open')) {
                    that.open();
                }
                else {
                    if(that.widgetType == 'event') {
                        profile.rsvp(that.widgetId, 1, true, function() {
                            clickTarget.addClass('active');
                        });
                    }
                    else {
                        profile.follow(that.widgetId, function() {
                            clickTarget.addClass('active');
                        });
                    }
                }
            }
            else {
                that.open();
            }
        }
    }

    open() {
        tracking.featuredCampaignClick(this.widgetCampaignId, this.widgetPosition);
        window.open(this.widgetUrl, '_blank');
    }
}


/**
* FeaturedCampaignsReportModal
*/

class FeaturedCampaignsReportModal {
    constructor(target, type, id) {
        if(!target || !target.length || !type || !id) {
            window.activeModalInstance = null;
            return;
        }

        // properties
        this.target = target;
        this.type = type;
        this.id = id;

        // init
        this.loadModal();
    }

    loadModal() {
        var that = this;

        this.target.html('<div class="campaign-panel"><div class="activity-indicator gray"></div></div>');
        this.target.show();

        new DataSender({
            data: { type: this.type, id: this.id },
            url: '/common/featured/report/',

            success: function(data) {
                if(data.status) {
                    that.target.html(data.html);
                    that.initModal();
                }
            },

            error: function() {
                that.target.hide();
            }
        });
    }

    initModal() {
        var that = this;
        var now = new Date();
        var today = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 23, 59, 59, 0);

        this.closeButton = this.target.find('button.close');
        this.closeButton.bind('click', function() {
            that.closeModal();
        });

        this.startDate = this.target.find('input[name="start-date"]');
        this.startDate.datepicker({
            format: window.evedo.dateFormat,
            weekStart: 1,
            onRender: function(date) {
                return date.valueOf() > today.valueOf() ? 'disabled' : '';
            }})
            .on('show', function(e) { that.startDate.prop('placeholder', ''); })
            .on('hide', function(e) { that.startDate.prop('placeholder', that.startDate.data('placeholder')); })
            .on('changeDate', function(e) {
                that.startDate.datepicker('hide').addClass('selected');
                that.startDateClear.show();
                that.filterReport();
            });

        this.endDate = this.target.find('input[name="end-date"]');
        this.endDate.datepicker({
            format: window.evedo.dateFormat,
            weekStart: 1,
            onRender: function(date) {
                return date.valueOf() > today.valueOf() ? 'disabled' : '';
            }})
            .on('show', function(e) { that.endDate.prop('placeholder', ''); })
            .on('hide', function(e) { that.endDate.prop('placeholder', that.endDate.data('placeholder')); })
            .on('changeDate', function(e) {
                that.endDate.datepicker('hide').addClass('selected');
                that.endDateClear.show();
                that.filterReport();
            });

        this.startDateClear = this.target.find('a.clear.start-date');
        this.startDateClear.bind('click', function() {
            that.startDate.datepicker('setValue', today).val('').removeClass('selected');
            that.startDateClear.hide();
            that.filterReport();
            return false;
        });

        this.endDateClear = this.target.find('a.clear.end-date');
        this.endDateClear.bind('click', function() {
            that.endDate.datepicker('setValue', today).val('').removeClass('selected');
            that.endDateClear.hide();
            that.filterReport();
            return false;
        });

        this.body = this.target.find('.modal-body');
        this.initList();
    }

    filterReport() {
        var that = this;

        this.body.html('<div class="activity-indicator gray"></div>');

        new DataSender({
            data: {
                type: this.type,
                id: this.id,
                start: this.startDate.val(),
                end: this.endDate.val(),
                list: true
            },
            url: '/common/featured/report/',

            success: function(data) {
                if(data.status) {
                    that.body.html(data.html);
                    that.initList();
                }
            }
        });
    }

    initList() {
        var that = this;

        this.campaigns = this.body.find('ul').find('li');
        this.campaigns.each(function() {
            var campaign = $(this);
            var campaignId = campaign.data('campaign-id');
            var campaignToggle = campaign.find('div.toggle');
            var campaignSwitch = campaign.find('label.new-switch input');
            var campaignPositions = campaign.find('div.positions');

            campaignToggle.bind('click', function(e) {
                if($(e.target).parents('label').length) {
                    return;
                }

                if(campaign.hasClass('opened')) {
                    campaign.removeClass('opened');
                    campaignPositions.animate({ height: 0 }, 250);
                }
                else {
                    campaign.addClass('opened');
                    campaignPositions.animate({ height: campaignPositions.data('height') }, 250);
                }
            });

            campaignSwitch.bind('change', function() {
                var checkbox = $(this);
                var active = checkbox.is(':checked') ? true : false;

                if(active) {
                    checkbox.parent().highlight('green', { hideEvent: 'mouseleave', offset: [-10, 0], placement: 'left', text: 'Resumed' });
                }
                else {
                    checkbox.parent().highlight('yellow', { hideEvent: 'mouseleave', offset: [-10, 0], placement: 'left', text: 'Paused' });
                }

                that.toggleCampaign(campaignId, active);
            });

            campaignPositions.data('height', campaignPositions.outerHeight());
            campaignPositions.find('a.hint').tooltip({ animation: false });

            if(!campaign.hasClass('opened')) {
                campaignPositions.height(0);
            }
        });
    }

    toggleCampaign(campaignId, active) {
        new DataSender({
            data: {
                id: campaignId,
                active: active ? 1 : 0
            },
            url: '/common/featured/toggle-campaign/'
        });
    }

    closeModal() {
        console.log(this.target)
        this.target.hide();
        $('body').removeClass('modal-open');
        $('.modal-backdrop').remove();

        window.activeModalInstance = null;
    }
}

/**
* FeatureModal
*/

const promoVouchersValue = 25.00;

class FeatureModal {
    constructor(target, type, id, callback) {
        if(!target || !target.length || !type || !id) {
            window.activeModalInstance = null;
            return;
        }

        // properties
        this.target = target;
        this.callback = (callback) ? callback : null;
        this.campaignOrderId = null;
        this.campaignTotalPrice = 0;
        this.data = {
            target_type: type,
            target_id: id,
            campaign_type_id: null,
            start_at: null,
            start_time: null,
            measurement_type_id: null,
            weight: null,
            positions: []
        };
        this.defaultCountOptions = [1000, 2000, 5000, 8000];

        this.currentStep = 0;
        this.locked = false;

        // init
        this.loadModal();
    }

    lock() {
        this.locked = true;
    }

    unlock() {
        this.locked = false;
    }

    slideToStep(step) {
        this.steps.css('-webkit-transform', 'translateX(' + (step * -750) + 'px)');
        this.steps.css('-moz-transform', 'translateX(' + (step * -750) + 'px)');
        this.steps.css('transform', 'translateX(' + (step * -750) + 'px)');

        if(step == 3) {
            this.navigation.css('-webkit-transform', 'translateX(-750px)');
            this.navigation.css('-moz-transform', 'translateX(-750px)');
            this.navigation.css('transform', 'translateX(-750px)');
        }
        else {
            this.navigation.css('-webkit-transform', 'translateX(0px)');
            this.navigation.css('-moz-transform', 'translateX(0px)');
            this.navigation.css('transform', 'translateX(0px)');
        }
    }

    back() {
        if(this.locked) return;
        this.lock();

        this.currentStep--;
        if(this.currentStep < 0) this.currentStep = 0;

        switch(this.currentStep) {
            case 0: this.closeSetupStep(); break;
            case 1: this.closePaymentStep(); break;
            case 2: this.closeFinishStep(); break;
        }
    }

    next() {
        if(this.locked) return;
        this.lock();

        this.currentStep++;
        if(this.currentStep > 3) this.currentStep = 3;

        switch(this.currentStep) {
            case 1: this.loadSetupStep(); break;
            case 2: this.loadPaymentStep(); break;
            case 3: this.loadFinishStep(); break;
        }
    }

    updateSummary(serializePositions) {
        var that = this;

        window.clearTimeout(this.summaryTimeout);
        this.summaryTimeout = window.setTimeout(function() {
            if(serializePositions === undefined || serializePositions) {
                that.serializePositions();
            }

            if(that.data.positions.length) {
                that.summaryPanelList.html('<div class="activity-indicator gray"></div>');
                that.showSummary();

                new DataSender({
                    data: that.data,
                    url: '/common/prices/calculate-feature/',

                    success: function(data) {
                        if(data.status) {
                            that.campaignTotalPrice = data.price;

                            var html = '';

                            for(var i in data.positions) {
                                html += '<li>';
                                html += '<strong><span>' + i + '</span><span>' + data.positions[i].price + '</span></strong>';

                                for(var j in data.positions[i].cities) {
                                    if(j != 'price') {
                                        html += '<span><span>' + data.positions[i].cities[j].city_name + ', ' + data.positions[i].cities[j].country_code + '</span><span>' + data.positions[i].cities[j].price + '</span></span>';
                                    }
                                }

                                html += '</li>';
                            }

                            that.summaryPanelList.html(html);
                            that.summaryPanelTotal.html(data.price_text);

                            that.summaryPanelTotal.parent().removeClass('limit-exceeded');
                            that.summaryPanelTotal.parent().removeHighlight();

                            if(that.campaignTotalPrice > promoVouchersValue) {
                                that.summaryPanelTotal.parent().addClass('limit-exceeded');
                                that.summaryPanelTotal.parent().highlight('red', { text: that.texts.exceededVoucherLimitErrorShort });
                            }
                            else if(that.campaignTotalPrice < promoVouchersValue) {
                                that.summaryPanelTotal.parent().highlight('green', { text: that.texts.amountLeft.replace(/%d/, '€' + (promoVouchersValue - that.campaignTotalPrice).toFixed(2)) });
                            }
                        }
                    }
                });
            }
            else {
                that.hideSummary();
            }
        }, 100);
    }

    showSummary() {
        this.target.addClass('show-summary-panel');
    }

    hideSummary() {
        this.target.removeClass('show-summary-panel');
    }

    collapsePreview() {
        this.campaignPanel.addClass('collapsed-preview');
    }

    expandPreview() {
        this.campaignPanel.removeClass('collapsed-preview');
    }

    setData(property, value) {
        var that = this;

        if(this.data[property] !== undefined) {
            this.data[property] = value;
            this.updateSummary();
        }
    }

    serializePositions() {
        var that = this;
        this.data.positions = [];

        this.campaignPositionsList.find('input:checked').each(function() {
            var positionKey = $(this).parent().data('position');
            var addedCities = that.campaignCitiesLists[positionKey].getArray();
            var cities = {};

            for(var i in addedCities) {
                cities[addedCities[i]] = that.campaignPositionsOptions.filter('[data-position="' + positionKey + '"]').find('.count').find('.row[data-city="' + addedCities[i] + '"]').find('input:checked').val();
            }

            that.data.positions.push({
                id: $(this).val(),
                cities: cities
            });
        });
    }

    checkData() {
        if(!this.data.campaign_type_id) {
            return false;
        }

        if(!this.data.start_at) {
            this.campaignStartDate.highlight('red', { text: this.texts.noStartDateError });
            this.setupStep.scrollTop(0);
            return false;
        }

        if(!this.data.start_time) {
            this.campaignStartTime.highlight('red', { text: this.texts.noStartTimeError });
            this.setupStep.scrollTop(0);
            return false;
        }

        if(!this.data.positions.length) {
            this.setupStep.find('.campaign-positions').highlight('red', { hideEvent: 'click', offset: [0, 20], text: this.texts.noPositionsError });
            this.setupStep.scrollTop(0);
            return false;
        }

        if(this.campaignTotalPrice > promoVouchersValue) {
            this.summaryPanelTotal.parent().addClass('limit-exceeded');
            this.summaryPanelTotal.parent().highlight('red', { placement: 'top', text: this.texts.exceededVoucherLimitErrorShort });
            return false;
        }
        else {
            this.summaryPanelTotal.parent().removeHighlight();
        }

        return true;
    }

    deleteOrder() {
        if(this.campaignOrderId) {
            new DataSender({
                data: { id: this.campaignOrderId },
                url: '/common/featured/delete-order/'
            });

            this.campaignOrderId = null;
        }
    }

    // 1. START:

    loadModal() {
        var that = this;

        this.target.html('<div class="campaign-panel"><div class="activity-indicator gray"></div></div>');
        this.target.show();

        new DataSender({
            data: { target_id: this.data.target_id },
            url: '/' + this.data.target_type + '/feature/load/',

            success: function(data) {
                if(data.status) {
                    that.target.html(data.html);
                    that.texts = window.featureModalTexts;
                    that.initModal();
                }
            },

            error: function() {
                that.closeModal();
            }
        });
    }

    initModal() {
        var that = this;

        this.campaignPanel = this.target.find('.campaign-panel');
        this.summaryPanel = this.target.find('.summary-panel');
        this.summaryPanelList = this.summaryPanel.find('ul');
        this.summaryPanelTotal = this.summaryPanel.find('div.total strong');
        this.steps = this.campaignPanel.find('.modal-body .wrapper');
        this.navigation = this.campaignPanel.find('.modal-footer');

        this.startStep = this.steps.find('.start');
        this.setupStep = this.steps.find('.setup');
        this.paymentStep = this.steps.find('.payment');
        this.finishStep = this.steps.find('.finish');

        this.campaignPanel.find('button.close').bind('click', function() {
            if(that.locked) return;

            if(that.data.positions.length) {
                if(window.confirm(that.texts.progressConfirm)) {
                    that.closeModal();
                }
            }
            else {
                that.closeModal();
            }
        });

        this.startStep.find('a').bind('click', function() {
            if($(this).data('campaign-type-id')) {
                that.data.campaign_type_id = $(this).data('campaign-type-id');
                that.next();
            }
            return false;
        });

        this.backButton = this.navigation.find('a:first-child');
        this.backButton.bind('click', function() {
            if(!$(this).hasClass('hidden')) {
                that.back();
            }
            return false;
        });

        this.nextButton = this.navigation.find('a:last-child');
        this.nextButton.bind('click', function() {
            if(!$(this).hasClass('hidden')) {
                that.next();
            }
            return false;
        });

        this.stepsBarControl = new StepsBarControl(this.navigation.find('.steps-bar-control'), {
            clicked: function(direction) {
                if(direction < 0) {
                    that.backButton.click();
                }
                else if(direction > 0) {
                    that.nextButton.click();
                }
            }
        });
        this.hideSummary();
    }

    closeModal() {
        console.log(this.target)
        this.deleteOrder();

        if(this.callback) {
            if(this.success) {
                this.callback({ success: true });
            }
            else {
                this.callback({ success: false });
            }
        }

        this.target.hide();
        $('body').removeClass('modal-open');
        $('.modal-backdrop').remove();


        window.activeModalInstance = null;
    }

    // 2. SETUP:

    loadSetupStep() {
        var that = this;

        if(this.data.campaign_type_id) {
            this.collapsePreview();
            this.backButton.removeClass('hidden');
            this.nextButton.removeClass('hidden');
            this.stepsBarControl.setActive(1);
            this.slideToStep(1);
            this.setupStep.html('<div class="activity-indicator gray"></div>');

            new DataSender({
                data: this.data,
                url: '/' + this.data.target_type + '/feature/setup/',

                success: function(data) {
                    if(data.status) {
                        that.setupStep.html(data.html);
                        that.initSetupStep();
                    }
                },

                error: function() {
                    that.unlock();
                }
            });
        }
    }

    initSetupStep() {
        var that = this;

        // DATE + TIME
        var now = new Date();
        var today = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 0, 0, 0, 0);

        this.campaignStartDate = this.setupStep.find('input[name="start-date"]');
        this.campaignStartTime = this.setupStep.find('input[name="start-time"]');

        this.campaignStartDate.datepicker({
            format: window.evedo.dateFormat,
            weekStart: 1,

            onRender: function(date) {
                return date.valueOf() < today.valueOf() ? 'disabled' : '';
            }
        })
            .on('show', function(e) { that.campaignStartDate.prop('placeholder', ''); })
            .on('hide', function(e) { that.campaignStartDate.prop('placeholder', that.campaignStartDate.data('placeholder')); })
            .on('changeDate', function(e) {
                that.setData('start_at', that.campaignStartDate.val());

                if(that.campaignStartTime.val() == '') {
                    that.campaignStartTime.val('00:00').removeHighlight();
                    that.setData('start_time', '00:00');
                }
            });

        this.campaignStartDate.datepicker('setValue', today);
        this.data.start_at = this.campaignStartDate.val();

        this.campaignStartTime.timepicker({
            defaultValue: 'value',
            showMeridian: false
        })
            .on('show.timepicker', function(e) { that.campaignStartTime.prop('placeholder', '') })
            .on('hide.timepicker', function(e) { that.campaignStartTime.prop('placeholder', that.campaignStartTime.data('placeholder')) })
            .on('change.timepicker', function(e) { that.setData('start_time', that.campaignStartTime.val()); });

        this.campaignStartTime.val('00:00');
        this.data.start_time = '00:00';

        // WEIGHT
        this.campaignWeight = this.setupStep.find('select[name="weight"]');

        if(this.campaignWeight.length) {
            this.campaignWeight.bind('change', function(e) {
                that.setData('weight', that.campaignWeight.val());
            });

            this.data.weight = that.campaignWeight.val();
        }
        else {
            this.data.weight = 1;
        }

        // MEASUREMENT
        this.campaignMeasurementTypes = this.setupStep.find('input[name="measurement"]');

        if(this.campaignMeasurementTypes.length) {
            this.campaignMeasurementTypes.bind('change', function(e) {
                var value = that.campaignMeasurementTypes.filter(':checked').val();
                that.setupStep.find('.campaign-positions p').html(that.texts.measurementTypesDescriptions[value - 1]);
                that.campaignPositionsOptions.find('div.count h4').text(that.texts.measurementTypes[value - 1]);
                that.setData('measurement_type_id', value);
            });

            this.data.measurement_type_id = this.campaignMeasurementTypes.filter(':checked').val();
        }
        else {
            this.data.measurement_type_id = 1;
        }

        // CAMPAIGN POSITIONS
        this.campaignPositionsList = this.setupStep.find('ul.positions-list').find('li');
        this.campaignPositionsList.bind('click', { reference: this }, this.campaignPositionClickHandler);
        this.campaignPositionsList.find('a').tooltip({ animation: false });

        // CAMPAIGN POSITIONS OPTIONS
        this.campaignPositionsOptions = this.setupStep.find('div.positions-options').find('div');
        this.campaignCitiesLists = {};

        this.campaignPositionsOptions.each(function() {
            var item = $(this);
            var positionKey = item.data('position');

            var cityInput = item.find('input[name="add-city"]');
            var countRows = item.find('div.count');

            that.campaignCitiesLists[positionKey] = new TokenList(item.find('ul.token-list'), positionKey, {
                added: function(data) {
                    html  = '<div class="row" data-city="' + data.value + '">';
                    for(var i in that.defaultCountOptions) {
                        html += '<label><input class="custom" name="' + positionKey + '-' + data.value + '" type="radio" value="' + that.defaultCountOptions[i] + '" /><span></span> ' + that.defaultCountOptions[i] + '</label>';
                    }
                    html += '</div>';

                    inputs = $(html).appendTo(countRows).find('input');
                    inputs.eq(0).prop('checked', 'checked');
                    inputs.bind('change', function() {
                        that.updateSummary();
                    });
                },

                removed: function(data) {
                    countRows.find('div[data-city="' + data.value + '"]').remove();
                },

                changed: function(data) {
                    var checkbox = that.campaignPositionsList.filter('[data-position="' + positionKey + '"]').find('input');

                    if(data.values.length) {
                        checkbox.prop('checked', 'checked');
                        item.find('h4.city, h4.measurement').removeClass('hidden');
                    }
                    else {
                        checkbox.removeProp('checked');
                        item.find('h4.city, h4.measurement').addClass('hidden');
                    }

                    if(!data.initiation) {
                        that.updateSummary();
                    }
                }
            });

            item.find('div.empty a').bind('click', function() {
                that.campaignCitiesLists[positionKey].add({
                    label: $(this).data('city'),
                    sublabel: '(' + $(this).data('country') + ')',
                    value: String($(this).data('id')),
                    remove: true
                });

                if(cityInput.length) {
                    cityInput.focus();
                }

                return false;
            });

            new CityAutocomplete(cityInput, {
                clear: true,
                callback: function(data) {
                    that.campaignCitiesLists[positionKey].add({
                        label: data.name,
                        sublabel: '(' + data.country_code + ')',
                        value: String(data.id),
                        remove: true
                    });

                    that.setupStep.scrollTop(that.setupStep[0].scrollHeight);
                }
            });
        });

        this.unlock();
    }

    campaignPositionClickHandler(e) {
        var that = e.data.reference;
        var item = $(this);
        var positionKey = item.data('position');

        if(!$(e.target).is('a')) {
            if(item.hasClass('active')) {
                that.campaignPositionsList.removeClass('active');
                that.campaignPositionsOptions.removeClass('active');
            }
            else {
                that.campaignPositionsList.removeClass('active');
                that.campaignPositionsOptions.removeClass('active');

                item.addClass('active');
                that.campaignPositionsOptions.filter('[data-position="' + positionKey + '"]').addClass('active').find('input[name="add-city"]').focus();

                that.setupStep.scrollTop(that.setupStep[0].scrollHeight);
            }
        }
        else {
            that.campaignCitiesLists[positionKey].removeAll();
            $(e.target).tooltip('hide');
        }
    }

    closeSetupStep() {
        var that = this;

        if(this.data.positions.length) {
            if(!window.confirm(this.texts.progressConfirm)) {
                this.currentStep++;
                this.unlock();
                return;
            }
        }

        this.data.campaign_type_id = null;
        this.data.start_at = null;
        this.data.start_time = null;
        this.data.measurement_type_id = null;
        this.data.weight = null;
        this.data.positions = [];

        this.expandPreview();
        this.updateSummary(false);

        this.backButton.addClass('hidden');
        this.nextButton.addClass('hidden');
        this.stepsBarControl.setActive(0);
        this.slideToStep(0);

        window.setTimeout(function() {
            that.setupStep.html('');
            that.unlock();
        }, 500);
    }

    // 3. PAYMENT:

    loadPaymentStep() {
        var that = this;

        if(!this.checkData()) {
            this.currentStep--;
            this.unlock();
            return;
        }

        this.backButton.removeClass('hidden');
        this.nextButton.addClass('hidden');
        this.stepsBarControl.setActive(2);
        this.slideToStep(2);
        this.paymentStep.html('<div class="activity-indicator gray"></div>');

        new DataSender({
            data: this.data,
            url: '/' + this.data.target_type + '/feature/payment/',

            success: function(data) {
                if(data.status) {
                    that.campaignOrderId = data.order;
                    that.campaignTotalPrice = data.price;
                    that.paymentStep.html(data.html);
                    that.initPaymentStep();
                }
            },

            error: function() {
                window.setTimeout(function() {
                    that.unlock();
                    that.back();
                }, 400);
            }
        });
    }

    initPaymentStep() {
        var that = this;

        var campaignPromoCode = this.paymentStep.find('input[name="code"]');
        var campaignSubmit = this.paymentStep.find('a.btn-primary');
        var checkPromoCodeTimeout = null;
        var validCode = false;

        campaignPromoCode.bind('input', function() {
            window.clearTimeout(checkPromoCodeTimeout);
            checkPromoCodeTimeout = window.setTimeout(function() {
                new DataSender({
                    data: { code: $.trim(campaignPromoCode.val()) },
                    url: '/common/featured/validate-promo-code/',

                    success: function(data) {
                        if(data.valid) {
                            campaignPromoCode.highlight('green', { hideEvent: 'input', placement: 'right', text: that.texts.validPromoCode });
                            validCode = true;
                        }
                        else {
                            campaignPromoCode.highlight('red', { hideEvent: 'input', placement: 'right', text: that.texts.invalidPromoCodeError });
                            validCode = false;
                        }
                    }
                });
            }, 300);
        });

        campaignPromoCode.data('placeholder', campaignPromoCode.prop('placeholder'));
        campaignPromoCode.bind('focus', function() { campaignPromoCode.prop('placeholder', ''); });
        campaignPromoCode.bind('blur', function() { campaignPromoCode.prop('placeholder', campaignPromoCode.data('placeholder')); });

        campaignSubmit.bind('click', function() {
            if(!$.trim(campaignPromoCode.val())) {
                campaignPromoCode.highlight('red', { placement: 'right', text: that.texts.noPromoCodeError });
            }
            else if(!validCode) {
                campaignPromoCode.highlight('red', { placement: 'right', text: that.texts.invalidPromoCodeError });
            }
            else if(that.campaignTotalPrice > promoVouchersValue) {
                campaignPromoCode.highlight('red', { placement: 'top', text: that.texts.exceededVoucherLimitError });
            }
            else {
                campaignSubmit.data('html', campaignSubmit.html()).html('<div class="activity-indicator"></div>');

                that.hideSummary();
                that.usedPromoCode = $.trim(campaignPromoCode.val());

                window.setTimeout(function() {
                    campaignSubmit.html(campaignSubmit.data('html'));
                    campaignPromoCode.removeHighlight();
                    that.next();
                }, 1000);
            }

            return false;
        });

        this.unlock();
    }

    closePaymentStep() {
        var that = this;

        this.deleteOrder();

        this.backButton.removeClass('hidden');
        this.nextButton.removeClass('hidden');
        this.stepsBarControl.setActive(1);
        this.slideToStep(1);

        window.setTimeout(function() {
            that.paymentStep.html('');
            that.unlock();
        }, 500);
    }

    // 4. FINISH:

    loadFinishStep(html) {
        var that = this;

        this.backButton.addClass('hidden');
        this.nextButton.addClass('hidden');
        this.slideToStep(3);
        this.finishStep.html('<div class="activity-indicator gray"></div>');

        new DataSender({
            data: {
                code: this.usedPromoCode,
                order: that.campaignOrderId
            },
            url: '/' + that.data.target_type + '/feature/finish/',

            success: function(data) {
                if(data.status) {
                    that.data.campaign_type_id = null;
                    that.data.start_at = null;
                    that.data.start_time = null;
                    that.data.measurement_type_id = null;
                    that.data.weight = null;
                    that.data.positions = [];
                    that.updateSummary(false);
                    that.campaignOrderId = null;

                    that.finishStep.html(data.html);
                    that.initFinishStep();
                }
                else {
                    window.setTimeout(function() {
                        that.unlock();
                        that.back();
                    }, 400);
                }
            },

            error: function() {
                window.setTimeout(function() {
                    that.unlock();
                    that.back();
                }, 400);
            }
        });
    }

    initFinishStep() {
        var that = this;

        this.finishStep.find('a.btn').bind('click', function() {
            that.closeModal();

            window.setTimeout(function() {
                if(that.data.target_type == 'event') {
                    profile.featuredEventReport(that.data.target_id);
                }
                else {
                    // profile.featuredPromoterReport(that.data.target_id);
                }
            }, 1000);

            return false;
        });

        this.success = true;
        this.unlock();
    }

    closeFinishStep() {
        var that = this;

        this.backButton.removeClass('hidden');
        this.nextButton.addClass('hidden');
        this.slideToStep(2);

        window.setTimeout(function() {
            that.finishStep.html('');
            that.showSummary();
            that.unlock();
        }, 500);
    }
}

/**
* StepsBarControl
*/

class StepsBarControl {
    constructor(target, options) {
        if(!target || !target.length) return;
        if(!options) options = {};

        this.target = target;
        this.clicked = (options.clicked) ? options.clicked : null;

        this.update();
        this.setActive(0);

        if(this.clicked) {
            var that = this;

            this.target.addClass('clickable');
            this.steps.bind('click', function() {
                var step = $(this);

                if(step.hasClass('past')) {
                    that.clicked(-1);
                }
                else if(step.hasClass('current')) {
                    that.clicked(0);
                }
                else {
                    that.clicked(1);
                }
            });
        }
    }

    update() {
        this.steps = this.target.find('div');
    }

    setActive(index) {
        this.steps.each(function(i) {
            var step = $(this);
            step.removeClass('past current');

            if(i < index) {
                step.addClass('past');
            }
            else if(i == index) {
                step.addClass('current');
            }
        });
    }
}

export { FeaturedWidget, FeaturedCampaignsReportModal, FeatureModal, StepsBarControl }
